<template>
  <div class="container cursor-pointer" @click.prevent="cardClick()">
    <div class="row">
      <!-- v-if="isACourse && availabilityForSale"-->
      <div
        v-if="item.tipo_produto === 'curso' && item.disp_venda_online"
        class="col-4 p-0 pr-4"
      >
        <div class="card-img__container">
          <img
            v-if="haveImage"
            class="card__img Card"
            :src="`https://loja.mundosenai.com.br/pub/media/catalog/product/${item.foto_card}`"
            alt="resultado da busca - imagem"
          />
          <img
            v-else
            class="card__img Card"
            src="/static/novomundosenai/imgs/card-cursos-default.svg"
            alt="resultado da busca - imagem padrão"
          />
        </div>
      </div>
      <div
        class="p-0 d-flex flex-column justify-content-between p-0"
        :class="{
          'col-8': item.disp_venda_online,
          'col-12': !item.disp_venda_online,
        }"
      >
        <div>
          <p :class="['item__flag', flagColor]" class="m-0">
            {{
              item.tipo_produto === 'vaga_trabalho'
                ? 'vagas de trabalho'
                : item.tipo_produto
            }}
          </p>
          <h6 class="h6__label--blue mt-2 mb-2">{{ item.nome }}</h6>
          <div :class="{ 'show-only-desktop': haveImage }">
            <p class="text__description--gray description-text--clamp-2">
              {{ item.descricao }}
            </p>
          </div>
        </div>
        <div
          v-if="
            item.tipo_produto === 'curso' &&
            item.disp_venda_online &&
            item.valor_final != 0
          "
        >
          <p class="text__prices description-text--clamp mt-2 mb-2">
            Valor total {{ formatCurrency(item.valor_final) }}
            <del v-if="item.valor_total !== item.valor_final">{{
              formatCurrency(item.valor_total)
            }}</del>
          </p>
          <p
            class="
              price__format price__format--small price__format--orange
              mt-2
              mb-2
              d-inline
            "
          >
            {{ item.qtde_parcelas }}x de
          </p>
          <p
            class="
              price__format price__format--orange price__format--big
              d-inline
            "
          >
            {{ formatCurrency(item.valor_parcela) }}
          </p>
        </div>
        <div
          v-if="
            item.tipo_produto === 'curso' &&
            item.disp_venda_online &&
            item.valor_final === 0
          "
        >
          <p
            class="
              price__format price__format--orange price__format--big
              d-inline
            "
          >
            Grátis
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatCurrency } from '@/utils/formatCurrency.js'
import { computed, toRefs } from '@vue/reactivity'
export default {
  name: 'SearchResultItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { item } = toRefs(props)
    const haveImage = computed(() => !!item.value.foto_card)
    const flagColor = computed(() => {
      if (['curso', 'jovem_aprendiz'].includes(item.value.tipo_produto))
        return 'item__flag--red'
      else if (
        ['vaga_trabalho', 'escola', 'estagio', 'evento'].includes(
          item.value.tipo_produto,
        )
      )
        return 'item__flag--blue'
      else if (['profissao'].includes(item.value.tipo_produto))
        return 'item__flag--purple'
    })

    function cardClick() {
      window.open(item.value.url, '_blank')
    }

    return {
      flagColor,
      haveImage,
      formatCurrency,
      cardClick,
    }
  },
}
</script>
